var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiFormStep',{attrs:{"title":_vm.questions[1],"prev":true,"next":true,"invalid":_vm.isInvalid},on:{"form:prev":function($event){return _vm.onPrev()},"form:next":function($event){return _vm.onNext()}}},[_c('UiFormField',{attrs:{"id":"contact-mentor-tellmore","label":null,"type":"radio","control":{
      name: 'tellmore',
      variant: 'buttons',
      options: _vm.transformAnswersToOptions(_vm.answers),
      value: _vm.formData.tellmore,
      required: true,
    }},on:{"input":function($event){return _vm.onRadioInput($event)},"invalid":function($event){return _vm.onInvalid($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }